import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.jsx";
import { App2 } from "./App2.jsx";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
// import { Work } from "./work.jsx";
// import { About } from "./about.jsx";
import { Skills } from "./components/Skills.jsx";
import WorkMain from "./workMain.jsx";
import { WorkSection } from "./work.jsx";
import App3 from "./App3.jsx";
import { Navbar } from "./components/Navbar.tsx";
import Contact from "./contact.jsx";
import MazeGame from "./components/MazeGame.jsx";
import MazeCircular from "./components/MazeCircular.jsx";
import { Dice } from "./components/Dice.jsx";
import Trails from "./components/Trails.jsx";
import DinoGame from "./components/DinoGame.jsx";
import WaterScene from "./Water.jsx";
import { Experience } from "./components/Rick/Experience.jsx";
import GlobeApp from "./components/GlobeMap/Globe.jsx";
import CityScene from "./components/GlobeMap/GlobeTwo.jsx";
import { TextSkills } from "./components/TextAnimation.jsx";
import CatEyes from "./components/Cat.jsx";
import SunScene from "./components/SunWireframe.jsx";
import TextParticles from "./components/FlowerText.jsx";
import Aviator from "./components/Aviator/Aviator.jsx";
import MarqueeMenu from "./components/Marquee/MarqueeMenu.jsx";
import { AppHome } from "./AppHome.jsx";
import ShapeOverlayMenu from "./components/Navbar/ShapeOverlayMenu";
import CardGrid from "./components/Home/Card.jsx";
import BackButton from "./components/BackButton.jsx";
import HideScrollbar from "./components/HideScrollbar.jsx";
import Hearts from "./components/Hearts/App.jsx";
import ScrollApp from "./components/ImageScroll/ScrollApp.tsx";
import Work from "./pages/Work.jsx";
import CaseStudy from "./pages/CaseStudy.jsx";
import SkillsFlythrough from "./pages/SkillsFlythrough.jsx";
import Test from "./pages/Test.jsx";
import DSA from "./pages/DSA.jsx";
import Audio from "./pages/Audio.jsx";
import Experiments from "./pages/Experiments.jsx";
import AI from "./pages/AI.jsx";
import WorkNew from "./pages/WorkNew.jsx";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <>
        {/* <Navbar /> */}
        <AppHome />
        {/* <ScrollApp /> */}
        {/* <CardGrid /> */}
        {/* <App /> */}
        {/* <Aviator /> */}
        {/* <CatEyes /> */}
        {/* <SunScene /> */}
      </>
    ),
  },
  // {
  //   path: "/skills",
  //   element: (
  //     <>
  //       <Navbar />
  //       <App2 />
  //     </>
  //   ),
  // },
  {
    path: "/work",
    element: <WorkNew />,
  },
  {
    path: "/skills",
    element: (
      <>
        <ShapeOverlayMenu darkBg />
        <SkillsFlythrough />
      </>
    ),
  },
  {
    path: "/work/:slug",
    element: <CaseStudy />,
  },
  {
    path: "/game",
    element: (
      <>
        <MazeCircular />
        {/* <MazeGame /> */}
      </>
    ),
  },
  {
    path: "/rick",
    element: (
      <>
        <Experience />
        {/* <MazeGame /> */}
      </>
    ),
  },
  {
    path: "/dice",
    element: (
      <>
        {/* <Dice /> */}
        <Hearts />
        {/* <MazeGame /> */}
      </>
    ),
  },
  {
    path: "/trails",
    element: (
      <>
        <Trails />
        {/* <MazeGame /> */}
      </>
    ),
  },
  {
    path: "/dino",
    element: (
      <>
        <HideScrollbar />
        <BackButton />
        <DinoGame />
      </>
    ),
  },
  {
    path: "/natrang",
    element: (
      <>
        <WaterScene />
        {/* <MazeGame /> */}
      </>
    ),
  },
  {
    path: "/globe",
    element: (
      <>
        {/* <GlobeApp /> */}
        {/* <CityScene /> */}
      </>
    ),
  },
  {
    path: "/text",
    element: (
      <>
        <TextSkills />
        {/* <GlobeApp /> */}
        {/* <CityScene /> */}
      </>
    ),
  },
  {
    path: "/test",
    element: <Test />,
  },
  {
    path: "/computer-vision",
    element: (
      <>
        <HideScrollbar />
        <BackButton />
        <Test />
      </>
    ),
  },
  {
    path: "/experiments",
    element: <Experiments />,
  },
  {
    path: "/dsa",
    element: (
      <>
        <HideScrollbar />
        <BackButton />
        <DSA />
      </>
    ),
  },
  {
    path: "/audio",
    element: (
      <>
        <HideScrollbar />
        <BackButton />
        <Audio />
      </>
    ),
  },
  {
    path: "/sun",
    element: (
      <>
        <HideScrollbar />
        <BackButton />
        <SunScene />
      </>
    ),
  },
  {
    path: "/ai",
    element: (
      <>
        <BackButton />
        <AI />
      </>
    ),
  },
  // {
  //   path: "/work-new",
  //   element: <WorkNew />,
  // },
]);

// The browser remembers each route's scroll offset and restores it on
// re-entry (e.g. back/forward, or mobile bfcache) — fine for a multi-page
// site, but in this client-routed SPA it makes a fresh visit to a page land
// mid-scroll if you'd previously scrolled down on it (the reported "Experiments
// loads at section 2/3" bug). Take over scroll position ourselves instead:
// reset to top on every route change.
if ("scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}
let lastPathname = window.location.pathname;
router.subscribe((state) => {
  const pathname = state.location.pathname;
  if (pathname !== lastPathname) {
    lastPathname = pathname;
    window.scrollTo(0, 0);
  }
});

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <HelmetProvider>
      <RouterProvider router={router} />
    </HelmetProvider>
  </React.StrictMode>,
);
